(function () {
  'use strict';

  var STORAGE_KEY = '__shopify_agent_context_events';
  var MAX_PRODUCTS = 10;

  var rendering = false;


  function getRecentlyViewedEvents() {
    try {
      /*
       * This is exactly the same storage access
       * that you confirmed works in the console.
       */
      var raw = window.sessionStorage[STORAGE_KEY];

      if (!raw) {
        return [];
      }

      var events = JSON.parse(raw);

      if (!Array.isArray(events)) {
        return [];
      }

      /*
       * Get only product_viewed events.
       */
      var viewed = events.filter(function (event) {
        return (
          event &&
          event.type === 'product_viewed' &&
          event.productId &&
          event.url
        );
      });

      /*
       * Most recently viewed first.
       */
      viewed.sort(function (a, b) {
        return Number(b.timestamp || 0) -
          Number(a.timestamp || 0);
      });

      /*
       * Remove duplicate product IDs.
       */
      var unique = [];
      var seen = {};

      viewed.forEach(function (event) {
        var id = String(event.productId);

        if (!seen[id]) {
          seen[id] = true;
          unique.push(event);
        }
      });

      return unique.slice(0, MAX_PRODUCTS);

    } catch (error) {
      console.error(
        'Recently Viewed - storage error:',
        error
      );

      return [];
    }
  }


  function getProductHandle(url) {
    try {
      var parsed = new URL(
        url,
        window.location.origin
      );

      var pathname = parsed.pathname;

      var match = pathname.match(
        /\/products\/([^\/?#]+)/
      );

      return match ? match[1] : null;

    } catch (error) {
      console.error(
        'Recently Viewed - handle error:',
        url,
        error
      );

      return null;
    }
  }


  function escapeHTML(value) {
    var div = document.createElement('div');

    div.textContent = value || '';

    return div.innerHTML;
  }


  async function fetchProduct(event) {
    var handle = getProductHandle(event.url);

    if (!handle) {
      return null;
    }

    try {
      var response = await fetch(
        '/products/' +
        encodeURIComponent(handle) +
        '.js'
      );

      if (!response.ok) {
        console.error(
          'Recently Viewed - product API failed:',
          handle,
          response.status
        );

        return null;
      }

      return await response.json();

    } catch (error) {
      console.error(
        'Recently Viewed - fetch failed:',
        handle,
        error
      );

      return null;
    }
  }


  function createCard(product) {
    if (!product) {
      return '';
    }

    var image = product.featured_image;

    if (
      !image &&
      product.images &&
      product.images.length
    ) {
      image = product.images[0];
    }

    if (!image) {
      console.warn(
        'Recently Viewed - no image:',
        product.title
      );

      return '';
    }

    return (
      '<a ' +
      'href="' + product.url + '" ' +
      'class="scd__recently-viewed-card"' +
      '>' +

      '<div class="scd__recently-viewed-image">' +

      '<img ' +
      'src="' + image + '" ' +
      'alt="' + escapeHTML(product.title) + '" ' +
      'loading="lazy" ' +
      'width="120" ' +
      'height="120"' +
      '>' +

      '</div>' +

      '<h4 class="scd__recently-viewed-card-title">' +
      escapeHTML(product.title) +
      '</h4>' +

      '</a>'
    );
  }


  async function renderRecentlyViewed() {

    if (rendering) {
      return;
    }

    var containers = document.querySelectorAll(
      '[data-recently-viewed]'
    );

    if (!containers.length) {
      return;
    }

    rendering = true;

    try {

      var events = getRecentlyViewedEvents();

      console.log(
        'Recently Viewed Events:',
        events
      );

      if (!events.length) {
        containers.forEach(function (container) {
          container.style.display = 'none';
        });

        return;
      }


      /*
       * Fetch Shopify product JSON.
       */
      var products = await Promise.all(
        events.map(function (event) {
          return fetchProduct(event);
        })
      );


      products = products.filter(function (product) {
        return product !== null;
      });


      console.log(
        'Recently Viewed Products:',
        products
      );


      containers.forEach(function (container) {

        var list = container.querySelector(
          '[data-recently-viewed-list]'
        );

        if (!list) {
          return;
        }

        if (!products.length) {
          container.style.display = 'none';
          return;
        }

        list.innerHTML = products
          .map(createCard)
          .join('');

        container.style.display = '';
      });

    } finally {
      rendering = false;
    }
  }


  /*
   * Watch for Minimog inserting/replacing
   * the cart drawer.
   */
  var observer = new MutationObserver(
    function (mutations) {

      var foundRecentlyViewed = false;

      mutations.forEach(function (mutation) {

        if (!mutation.addedNodes.length) {
          return;
        }

        mutation.addedNodes.forEach(function (node) {

          if (node.nodeType !== 1) {
            return;
          }

          if (
            node.matches &&
            node.matches('[data-recently-viewed]')
          ) {
            foundRecentlyViewed = true;
          }

          if (
            node.querySelector &&
            node.querySelector(
              '[data-recently-viewed]'
            )
          ) {
            foundRecentlyViewed = true;
          }

        });

      });


      if (foundRecentlyViewed) {
        /*
         * Wait until Minimog has finished
         * inserting the drawer.
         */
        setTimeout(
          renderRecentlyViewed,
          50
        );
      }
    }
  );


  /*
   * Start observing the page.
   */
  function init() {

    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );

    /*
     * Handles the case where the drawer
     * already exists on page load.
     */
    renderRecentlyViewed();

  }


  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      init
    );

  } else {

    init();

  }

})();